'use client';

import {
  Box,
  useRecipe,
  type BoxProps,
  type RecipeVariantProps,
} from '@react/chakra';

import type { JSX } from 'react';
import type { ITopicVMProps } from '@data/view-models';

import { topicRecipe } from './recipe';
import { useTopicQuery } from '../hooks';

interface ITopicProps extends BoxProps, RecipeVariantProps<typeof topicRecipe> {
  selected?: boolean;
  data: ITopicVMProps;
}

export function Topic({
  data,
  size = 'xl',
  selected = false,
  variant = 'selectable',
  ...rest
}: ITopicProps): JSX.Element {
  const { name, slug } = data;
  const [topicQuery, setTopicQuery] = useTopicQuery();

  const recipe = useRecipe({
    recipe: topicRecipe,
  });

  const styles = recipe({
    size,
    variant,
  });

  const handleClick = () => {
    let newTopics = topicQuery || [];

    if (selected) {
      newTopics = newTopics.filter((e) => e !== slug);
    } else {
      newTopics.push(slug);
    }

    setTopicQuery([...newTopics]);
  };

  return (
    <Box
      css={styles}
      onClick={handleClick}
      data-status={selected ? 'active' : undefined}
      {...rest}
    >
      {name}
    </Box>
  );
}
